import { render } from "./ContactView.vue?vue&type=template&id=0115f8c7&ts=true&lang=pug"
import script from "./ContactView.vue?vue&type=script&lang=ts"
export * from "./ContactView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/danielwu/Documents/bearathome/bat-project/bat-org-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__